import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,
  
  Avatar,
  InputAdornment,
  Card,
  CardContent,

} from '@mui/material';

import PaginationItem from '@mui/material/PaginationItem';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';   
import Scrollbar from '../components/scrollbar/Scrollbar';

import { Api, UploadFile } from '../webservices';
import Header from './Header'
import Footer from './Footer'

const About = () => {

  const navigate = useNavigate()

  const teamMembers = [
    {
      name: 'John Doe',
      role: 'CEO & Founder',
      image: 'https://via.placeholder.com/150',
    },
    {
      name: 'Jane Smith',
      role: 'Chief Technology Officer',
      image: 'https://via.placeholder.com/150',
    },
    {
      name: 'Michael Brown',
      role: 'Lead Designer',
      image: 'https://via.placeholder.com/150',
    },
  ];

  const coreValues = [
    {
      title: 'Integrity',
      description: 'We believe in honesty and transparency in all our dealings.',
    },
    {
      title: 'Innovation',
      description: 'We constantly strive to redefine the standard of excellence.',
    },
    {
      title: 'Customer Focus',
      description: 'We prioritize customer satisfaction above all sdjireret rtrt.',
    },
  ];

  const employees = [
    {
      name: "John Doe",
      profile: "Founder & CEO",
      jobDescription: "A visionary leader with a passion for innovation, Name drives Foxearch's mission to transform recruitment technology.",
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/team_2.jpg",
    },
    {
      name: "Alice Smith",
      profile: "Project Manager",
      jobDescription: "Name  ensures operational excellence, bringing years of expertise in managing and scaling tech-driven solutions.",
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/team_3.jpg",
    },
    {
      name: "Michael Johnson",
      profile: "Partner",
      jobDescription: "Name plays a pivotal role in promoting Foxearch's values and expanding its reach in the global recruitment market.",
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/team_5.jpg",
    }
  ];


  return (

    <>

      {/* <Stack backgroundColor={'text.secondary'}>

        <Stack
          flexDirection={'row'}
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          sx={{
            padding: 3, mt: 1.5, mb: 1.5,
            flexWrap: 'nowrap', alignItems: 'center'
          }}
        >

          <Stack flexDirection={'row'} gap={3} >
            <Typography color="white">
              Foxearch Icon
            </Typography>
            <Typography color="white" sx={{ ml: 11, cursor: 'pointer' }} onClick={() => navigate('/home')}>
              Home
            </Typography>
            <Typography color="white" sx={{ cursor: 'pointer' }} onClick={() => navigate('/contactUs')}>
              Contact Us
            </Typography>
          </Stack>

          <Stack
            flexDirection="row"
            gap={2}
            sx={{ flexWrap: 'nowrap', alignItems: 'center' }}
          >

            <Iconify icon="fontisto:world-o" width="2rem" color="white" sx={{ cursor: "pointer" }} />
            <Typography color="white" sx={{ cursor: "pointer", marginRight: 4 }} onClick={() => navigate('/login')}>Sign In</Typography>
            <Button
              sx={{
                backgroundColor: "white",
                // color: "transparent", 
                '&:hover': {
                  backgroundColor: "white",
                  // color: "transparent"
                }
              }}
            >
              Request Demo
            </Button>

          </Stack>

        </Stack>
        <Divider sx={{ borderColor: "white" }} />
        <Box

          sx={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: '#fff',
            py: 8,
            textAlign: 'center'
          }}
        >
          <Container>
            <Typography variant="h2" gutterBottom>
              About Us
            </Typography>
            <Typography variant="h6">
              We are committed to delivering the best solutions for your needs.
            </Typography>
          </Container>
        </Box>
      </Stack>

      <Container sx={{ mt: 4 }}> 
        <Typography variant="h4" gutterBottom>
          Who We Are
        </Typography>
        <Typography variant="body1" paragraph>
          Our company is dedicated to providing top-notch solutions for our clients.
          With a team of experienced professionals, we strive to bring innovation and excellence to every project.
        </Typography>
        <Typography variant="body1" paragraph>
          Our mission is to enhance the business growth of our customers with creative design, development, and to deliver market-defining high-quality solutions that create value and reliable competitive advantage for our clients.
        </Typography>
      </Container>

      <Stack
        sx={{
          padding: 3,
          alignItems: 'center',
          mt: 5,

          // backgroundColor: 'rgba(82, 130, 210, 0.09)' 
          backgroundColor: '#EAF1FE'
        }}
      >
        <Container sx={{ mt: 1, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Meet Our Team
          </Typography>
          <Grid container spacing={4}>
            {teamMembers?.map((member, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card>
                  <CardContent>
                    <Box display="flex" flexDirection="column" alignItems="center">
                      <Avatar
                        src={member.image}
                        alt={member.name}
                        sx={{ width: 120, height: 120, mb: 2 }}
                      />
                      <Typography variant="h6">{member.name}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        {member.role}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

      </Stack>

      <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Our Values
        </Typography>
        <Grid container spacing={4} sx={{}}>
          {coreValues.map((value, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  mb: 5,
                  textAlign: 'center',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.3)',
                  },
                }}
              >
                <Typography variant="h5" gutterBottom>
                  {value.title}
                </Typography>
                <Typography variant="body1">{value.description}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

      </Container>
      <Stack
        sx={{
          alignItems: 'center',
          py: 5,
          backgroundColor: '#003366',
          color: 'white',
          mt: 5,
        }}
      >
        <Typography variant="h4" gutterBottom>
          Interested in working with us?
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#FF6600',
            '&:hover': { backgroundColor: '#E55D00' },
          }}
          onClick={() => navigate('/contactUs')}
        >
          Get in Touch
        </Button>
      </Stack> */}

      <div id="body" className="page-template page-template-page-templates page-template-full-width page-template-page-templatesfull-width-php page page-id-1277 wp-custom-logo theme-deepdigital woocommerce-no-js tribe-no-js page-template-deepdigital yith-wcbm-theme-deepdigital singular no-sidebar container-1170 meta-icons-main woo header-sticky animation-enabled elementor-default elementor-kit-2882 elementor-page elementor-page-1277" itemType="https://schema.org/WebPage" itemScope="itemscope" data-animate='{&quot;.footer-widgets .widget&quot;:&quot;fadeInUp&quot;}'
      >

        <button id="login_modal_close" aria-controls="login_dropdown" className="nav-btn" aria-expanded="true" aria-label="Login Toggler" />

        {/* </button> */}
        <div id="box" className="box-fade-in">
          <div id="top-wrap">


            <Header />
            <section id="title" className="title title-3 text-center polygon l m fs-12 background-cover cover-center nw_tbar">
              <div className="container ">
                <h1 itemProp="headline" style={{ color: '#ed457a' }}>About Us</h1>
                <h6 style={{color:'#fff'}}>
                Your success is our priority: We Listen, Adapt, and Evolve with you                </h6>
                <nav className="breadcrumbs"><span><span><Link to ="/home">Home</Link></span> &bull;
                 <span className="breadcrumb_last" aria-current="page">About</span>
                 </span></nav>    
            </div>
            </section>
          </div>
          <div data-elementor-type="wp-page" data-elementor-id="1277" className="elementor elementor-1277">
            <section className="elementor-section elementor-top-section elementor-element elementor-element-1b6fdc6 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="1b6fdc6" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e46c446" data-id="e46c446" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                   
                    {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-d76d449 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="d76d449" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-81730a1" data-id="81730a1" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-2932333 elementor-widget elementor-widget-heading" data-id="2932333" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h5 className="elementor-heading-title elementor-size-default" style={{ color: '#3c6ba5' }}>Who We Are</h5>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-ff80486 elementor-widget elementor-widget-text-editor" data-id="ff80486" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                <p style={{ color: '#000' }}> Leaders in Recruitment Technology: Foxearch specializes in crafting intuitive software solutions that empower recruiters and HR professionals.</p>
                                <p style={{ color: '#000' }}> Simplifying Recruitment: We provide tools that streamline every stage of the hiring process, ensuring seamless operations from candidate sourcing to onboarding.</p>
                                <p style={{ color: '#000' }}> AI-Powered Solutions: Our platform incorporates advanced AI features that assist in candidate matching, predictive analytics, and automating repetitive tasks, making recruitment smarter and faster.</p>
                                <p style={{ color: '#000' }}> Committed to Excellence: Our focus is on delivering unparalleled user experiences, making recruitment efficient and effective.</p>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section> */}

                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-f8e9968 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="f8e9968" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e39c92d" data-id="e39c92d" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-7d8fba0 elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" data-id="7d8fba0" data-element_type="widget" data-widget_type="icon.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-icon-wrapper">
                                  <div className="elementor-icon elementor-animation-pop">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
                                      <path d="M995.52 906.752c-6.432-4.256-123.136-80.8-296.736-118.368 63.68-80.672 104.576-189.184 121.952-261.408 24.128-100.096 14.752-295.936-81.376-417.984-56.192-71.328-134.816-108.992-227.36-108.992s-171.168 37.696-227.328 108.992c-96.128 122.016-105.472 317.856-81.376 417.952 17.376 72.224 58.24 180.736 121.952 261.408-173.6 37.568-290.304 114.112-296.704 118.368-23.456 15.616-33.952 44.8-25.76 71.744 8.128 27.040 33.056 45.536 61.216 45.536h896c28.192 0 53.056-18.496 61.248-45.504 8.224-26.944-2.272-56.128-25.728-71.744zM648.544 748.736l-10.432 13.248c-76.32 87.68-175.84 87.68-252.128 0l-10.464-13.248c-89.12-112.928-133.344-262.304-114.304-404.8 17.44-136.928 95.904-279.936 250.784-279.936s233.376 143.040 250.816 279.968c18.976 142.56-25.088 291.776-114.272 404.768zM64 960c4.416-2.944 112.832-74.048 274.752-109.056l79.488-17.184c28.384 18.624 59.52 30.24 93.76 30.24 34.272 0 65.376-11.616 93.76-30.24l79.488 17.184c160.64 34.752 268.672 105.056 274.752 109.056h-896z"
                                      />
                                    </svg>			</div>
                                </div>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-02123db elementor-widget elementor-widget-heading" data-id="02123db" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Who We Are</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-f83b117 elementor-widget elementor-widget-text-editor" data-id="f83b117" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                              Leaders in Recruitment Technology: Foxearch specializes in crafting intuitive software solutions that empower recruiters and HR professionals                                </div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-2403aa7" data-id="2403aa7" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-75baae5 elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-spacer" data-id="75baae5" data-element_type="widget" data-widget_type="spacer.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-spacer">
                                  <div className="elementor-spacer-inner" />
                                </div>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-dfc6f59 elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" data-id="dfc6f59" data-element_type="widget" data-widget_type="icon.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-icon-wrapper">
                                  <div className="elementor-icon elementor-animation-pop">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
                                      <path d="M1005.248 309.664l-162.56-162.592c-12-12-28.32-18.752-45.248-18.752h-570.848c-16.96 0-33.248 6.752-45.248 18.752l-162.56 162.592c-12.576 12.544-18.848 29.088-18.784 45.664 0.096 15.040 5.472 30.048 16.192 42.112l447.968 477.056c12.16 13.696 29.568 21.504 47.84 21.504s35.68-7.808 47.808-21.504l448-477.056c10.944-12.32 16.32-27.744 16.192-43.136-0.128-16.192-6.432-32.32-18.752-44.64zM583.008 352.32h-142.048l71.040-59.168 71.008 59.168zM537.024 272.32l87.424-72.896 64.576 64.576-81.024 67.488-70.976-59.168zM416 331.488l-81.024-67.488 64.576-64.576 87.456 72.896-71.008 59.168zM591.68 384.32l-79.68 398.496-79.68-398.496h159.36zM624.32 384.32h156.992l-235.488 392.608 78.496-392.608zM632.928 352.32l78.816-65.632 65.632 65.632h-144.448zM662.624 192.32h112.384l-61.312 51.104-51.072-51.104zM512 251.52l-71.040-59.2h142.016l-70.976 59.2zM310.272 243.424l-61.312-51.104h112.416l-51.104 51.104zM312.256 286.688l78.784 65.632h-144.416l65.632-65.632zM399.68 384.32l78.496 392.608-235.52-392.608h157.024zM406.528 719.616l-314.88-335.296h113.728l201.152 335.296zM818.624 384.32h113.76l-314.944 335.36 201.184-335.36zM822.624 352.32l-86.176-86.176 73.504-61.28 147.424 147.456h-134.752zM213.952 204.8l73.632 61.344-86.208 86.176h-137.184l149.76-147.52z"
                                      /></svg>			</div>
                                </div>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-3470459 elementor-widget elementor-widget-heading" data-id="3470459" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">What We Do</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-c948364 elementor-widget elementor-widget-text-editor" data-id="c948364" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                              We provide tools that streamline every stage of the hiring process, ensuring seamless operations from candidate sourcing to onboarding.

                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-097050c" data-id="097050c" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-74285bb elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon" data-id="74285bb" data-element_type="widget" data-widget_type="icon.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-icon-wrapper">
                                  <div className="elementor-icon elementor-animation-pop">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
                                      <path d="M933.248 335.104c-40-10.496-134.048-10.368-271.616-14.016 6.496-30.016 8-57.088 8-105.152 0-114.816-83.648-215.936-157.632-215.936-52.256 0-95.328 42.72-96 95.264-0.704 64.448-20.64 175.744-128 232.192-7.872 4.16-30.4 15.264-33.696 16.704l1.696 1.44c-16.8-14.496-40.096-25.6-64-25.6h-96c-52.928 0-96 43.072-96 96v512c0 52.928 43.072 96 96 96h96c38.080 0 69.952-23.008 85.376-55.264 0.384 0.128 1.056 0.32 1.504 0.384 2.112 0.576 4.608 1.184 7.648 1.984 0.576 0.16 0.864 0.224 1.472 0.384 18.432 4.576 53.92 13.056 129.76 30.496 16.256 3.712 102.144 22.016 191.104 22.016h174.944c53.312 0 91.744-20.512 114.624-61.696 0.32-0.64 7.68-15.008 13.696-34.432 4.512-14.624 6.176-35.328 0.736-56.32 34.368-23.616 45.44-59.328 52.64-82.56 12.064-38.112 8.448-66.752 0.064-87.264 19.328-18.24 35.808-46.048 42.752-88.512 4.32-26.304-0.32-53.376-12.448-75.904 18.112-20.352 26.368-45.952 27.328-69.632l0.384-6.688c0.224-4.192 0.416-6.784 0.416-16 0-40.416-28-91.968-90.752-109.888zM224 928c0 17.696-14.304 32-32 32h-96c-17.696 0-32-14.304-32-32v-512c0-17.696 14.304-32 32-32h96c17.696 0 32 14.304 32 32v512zM959.264 465.12c-0.64 15.808-7.264 46.88-63.264 46.88-48 0-64 0-64 0-8.864 0-16 7.168-16 16s7.136 16 16 16c0 0 14.016 0 62.016 0s54.304 39.808 51.2 59.008c-3.968 23.872-15.168 68.992-69.216 68.992-53.984 0-76 0-76 0-8.864 0-16 7.136-16 16 0 8.8 7.136 16 16 16 0 0 38.016 0 63.008 0 54.016 0 49.248 41.184 41.504 65.76-10.208 32.288-16.448 62.24-84.512 62.24-23.008 0-52.192 0-52.192 0-8.864 0-16 7.136-16 16 0 8.8 7.136 16 16 16 0 0 22.176 0 50.176 0 35.008 0 36.64 33.12 32.992 44.992-4 12.992-8.736 22.624-8.928 23.072-9.664 17.44-25.248 27.936-58.24 27.936h-174.944c-87.872 0-175.040-19.936-177.28-20.448-132.928-30.624-139.936-32.992-148.288-35.36 0 0-27.072-4.576-27.072-28.192l-0.224-441.984c0-15.008 9.568-28.576 25.408-33.344 1.984-0.768 4.672-1.6 6.592-2.4 146.176-60.544 190.688-193.28 192-302.272 0.192-15.328 12-32 32-32 33.824 0 93.632 67.904 93.632 151.936 0 75.872-3.072 88.992-29.632 168.064 320 0 317.76 4.608 345.984 12 35.008 10.016 38.016 39.008 38.016 48.992 0 10.976-0.32 9.376-0.736 20.128zM144 832c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM144 896c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                                      /></svg>			</div>
                                </div>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-b84f018 elementor-widget elementor-widget-heading" data-id="b84f018" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Why We Do It</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-fda4be6 elementor-widget elementor-widget-text-editor" data-id="fda4be6" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                              We are truly passionate about what we do, and that enthusiasm genuinely shines through in the exceptional quality of our work.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                   
                  </div>
                </div>
              </div>
            </section>
            <section className="elementor-section elementor-top-section elementor-element elementor-element-208d345 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="208d345" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-49d97d8" data-id="49d97d8" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-9286bf4 elementor-widget elementor-widget-gallery-carousel" data-id="9286bf4" data-element_type="widget" data-settings="{&quot;data_responsive_lg&quot;:4,&quot;data_margin&quot;:10,&quot;items_layout&quot;:&quot;item-regular&quot;,&quot;data_loop&quot;:&quot;yes&quot;,&quot;data_autoplay&quot;:&quot;yes&quot;,&quot;data_autoplaytimeout&quot;:3000,&quot;data_center&quot;:&quot;yes&quot;,&quot;data_responsive_sm&quot;:2,&quot;data_responsive_xs&quot;:1,&quot;data_nav&quot;:&quot;yes&quot;,&quot;nav_layout&quot;:&quot;nav-layout-2&quot;}" data-widget_type="gallery-carousel.default">
                      <div className="elementor-widget-container">
                        <div className="owl-carousel-container">
                          <div id="widget_portfolio_carousel_67d022284f405" className="owl-carousel gallery-slider nav-layout-2" data-loop="true" data-autoplay="true" data-autoplaytimeout="3000" data-center="true" data-nav="true" data-margin="10" data-responsive-lg="4" data-responsive-sm="2" data-responsive-xs="1" data-filters=".carousel_filters-67d022284f405">
                            <div className="owl-carousel-item web-design">
                              <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_15-800x800.jpg" alt="Sadipscing elitr sed" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                                <span className="mwt-elementor-gallery-carousel-categories">
                                  Web Design										</span>
                                <a href="https://webdesign-finder.com/deepdigital-v2/single-project-1-2/" className="mwt-elementor-gallery-carousel-title">
                                  Sadipscing elitr sed										</a>
                              </div>
                            </div>
                            <div className="owl-carousel-item averticement">
                              <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_16-800x800.jpg" alt="Lorem ipsum dolor" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                                <span className="mwt-elementor-gallery-carousel-categories">
                                  Averticement										</span>
                                <a href="https://webdesign-finder.com/deepdigital-v2/single-project-1-2/" className="mwt-elementor-gallery-carousel-title">
                                  Lorem ipsum dolor										</a>
                              </div>
                            </div>
                            <div className="owl-carousel-item logo-design">
                              <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_17-800x800.jpg" alt="Sitamet consetetur" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                                <span className="mwt-elementor-gallery-carousel-categories">
                                  Logo Design										</span>
                                <a href="https://webdesign-finder.com/deepdigital-v2/single-project-1-2/" className="mwt-elementor-gallery-carousel-title">
                                  Sitamet consetetur										</a>
                              </div>
                            </div>
                            <div className="owl-carousel-item branding">
                              <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-800x800.jpg" alt="Sadipscing elitr sed diam" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                                <span className="mwt-elementor-gallery-carousel-categories">
                                  Branding										</span>
                                <a href="https://webdesign-finder.com/deepdigital-v2/single-project-1-2/" className="mwt-elementor-gallery-carousel-title">
                                  Sadipscing elitr sed diam										</a>
                              </div>
                            </div>
                            <div className="owl-carousel-item photo">
                              <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_19-800x800.jpg" alt="Elitr sed diam nonumy" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                                <span className="mwt-elementor-gallery-carousel-categories">
                                  Photo										</span>
                                <a href="https://webdesign-finder.com/deepdigital-v2/single-project-1-2/" className="mwt-elementor-gallery-carousel-title">
                                  Elitr sed diam nonumy										</a>
                              </div>
                            </div>
                            <div className="owl-carousel-item design">
                              <img decoding="async" className="slide-image" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-800x800.jpg" alt="Magna aliquyam erat sed" />																<div className="mwt-elementor-gallery-carousel-content-wrap">
                                <span className="mwt-elementor-gallery-carousel-categories">
                                  Design										</span>
                                <a href="https://webdesign-finder.com/deepdigital-v2/single-project-1-2/" className="mwt-elementor-gallery-carousel-title">
                                  Magna aliquyam erat sed										</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 
              </div>
            </section>

           <section
  className="elementor-section elementor-top-section elementor-element elementor-element-53b656a elementor-section-full_width elementor-section-height-default elementor-section-height-default"
  data-id="53b656a"
  data-element_type="section"
  style={{backgroundColor:"white"}}
>
  <div className="elementor-container elementor-column-gap-default">
    <div
      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-81bf45f"
      data-id="81bf45f"
      data-element_type="column"
    >
      <div className="elementor-widget-wrap elementor-element-populated">
        <div
          className="elementor-element elementor-element-514cd90 members-defaults-yes members-defaults-hover-background-yes elementor-widget elementor-widget-team-slider"
          data-id="514cd90"
          data-element_type="widget"
          data-widget_type="team-slider.default"
        >
          <div className="elementor-widget-container">
            <div className="flexslider-container mwt-team-slider-container">
              <h3 className="slider-title mwt-elementor-team-slider-title">team</h3>
              <div
                className="flexslider team-slider"
                data-slideshow="1"
                data-slideshowspeed="3000"
                data-animation="fade"
              >
                <ul className="slides">

               <li>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between", 
      gap: "20px",
      width: "100%",
    }}
  >
    <li className="menu__item" style={{marginLeft:"20px"}}>
                                <span className="mwt-elementor-team-slider-position">
                                Naveen Kumar
                                                        </span>
                                                        <br/>
                                {/* <span className="mwt-elementor-team-slider-position">
                                Ayush Dwivedi COO                            </span> */}
                                <span className="mwt-elementor-team-slider-name">
                                Founder                           </span>
                              </li>

    <img   
      decoding="async"
      className="swiper-slide-image"
      style={{
        width: "45%",
        height: "auto",
        objectFit: "cover",
        borderRadius: "10px",
      }}
      src="./assets/images/home/Naveen_Kumar_team1.png"
      alt=""
    />
  </div>
</li>

<li>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "20px",
      width: "100%",
    }}
  >

<li className="menu__item" style={{marginLeft:"20px"}}>
                                <span className="mwt-elementor-team-slider-position">
                                 Forood Malekzadeh
                                                        </span>
                                                        <br/>
                                <span className="mwt-elementor-team-slider-position">
                                {/* <span className="mwt-elementor-team-slider-name"> */}
                                Sr. Partner                        </span>
                              </li>

    <img
      decoding="async"
      className="swiper-slide-image"
      style={{
        width: "45%",
        minHeight: "100%",
        objectFit: "cover",
        borderRadius: "10px",
      }}
      src="./assets/images/home/Forood_Malekzadeh_Sr._Partner_team2.png"
      alt=""
    />
  </div>
</li>

                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

            <section className="elementor-section elementor-inner-section elementor-element elementor-element-d76d44877 elementor-section-boxed elementor-section-height-default elementor-section-height-default mar" data-id="d76d449" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-81730a1" data-id="81730a1" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-2932333 elementor-widget elementor-widget-heading" data-id="2932333" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h5 className="elementor-heading-title elementor-size-default" style={{color: '#3c6ba5','font-weight': '400'}}>At Foxearch, we’re not just offering software; we’re empowering<br/> recruiters to achieve more with less effort. Join us as we revolutionize recruitment with AI-driven insights and solutions!</h5>		
                                </div>
                            </div>
                            {/* <div className="elementor-element elementor-element-ff80486 elementor-widget elementor-widget-text-editor" data-id="ff80486" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                <p style={{ color: '#000' }}> Welcome to Foxearch, where we are redefining the recruitment industry with our state-of-the-art ATS (Applicant Tracking System) and CRM (Customer Relationship Management) solutions. Our mission is to simplify recruitment processes, enabling businesses to track and manage every task effortlessly. With the best-in-className user interface and guaranteed simplicity, Foxearch is the ultimate tool for recruiters seeking efficiency and innovation. Plus, our advanced AI features enhance your recruitment capabilities like never before!</p>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </section>
            {/* <section className="elementor-section elementor-top-section elementor-element elementor-element-80eef7d elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="80eef7d" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-35e683f" data-id="35e683f" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-f79e09f elementor-widget elementor-widget-google_maps" data-id="f79e09f" data-element_type="widget" data-widget_type="google_maps.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-custom-embed">
                          <iframe loading="lazy"
                            src="https://maps.google.com/maps?q=2231%20Sycamore%20Lake%20Road%20Green%20Bay%2C%20WI%2054304&#038;t=m&#038;z=11&#038;output=embed&#038;iwloc=near"
                            title="2231 Sycamore Lake Road Green Bay, WI 54304"
                            aria-label="2231 Sycamore Lake Road Green Bay, WI 54304"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}
            <section className="elementor-section elementor-inner-section elementor-element elementor-element-d76d449 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="d76d449" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-81730a1" data-id="81730a1" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-2932333 elementor-widget elementor-widget-heading" data-id="2932333" data-element_type="widget" data-widget_type="heading.default">
                      <div className="elementor-widget-container">
                        <h5 className="elementor-heading-title elementor-size-default" style={{ color: 'rgb(237 69 122)','margin-bottom': '35px','margin-top': '10px','font-weight': '600' }}>|| Committed to Excellence ||</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          
          
        </div>
        <Footer />
        <a id="to-top" href="#body">
          <span className="screen-reader-text">
            Go to top		</span>
        </a>

      </div>
    </>

  );
};

export default About;
